import {Api_devKfsjbxxcx} from '@/static/js/api/dev/devinfo'
import StoreSaveData from '@/static/js/storeSaveData'

export default {
    state: {
        info: {
            dwzh: '',
            dwjcrs: '',
            dwfcrs: '',
            dwzhye: '',
            dwjcbl: '',
            dwkhrq: '',
            jzny: '',
            dwzhzt: '',
            jgbm: '',
            jgmc: '',
            dwmc: '',
            dwjm: '',
            dwdz: '',
            zjjgdm: '',
            dwslrq: '',
            dwyb: '',
            dwfxr: '',
            dwfrdbxm: '',
            dwfrdbzjhm: '',
            jbrxm: '',
            jbrzjhm: '',
            jbrgddhhm: '',
            jbrsjhm: '',
            dwlsgx: '',
            dwxz: '',
            dwjjlx: '',
            dwsshy: '',
            jglx: '',
            zjly: '',
            sbzh: ''
        },
        loading: true
    },
    mutations: {
        devinfoAdd(state, obj) {
            state.info = obj;
        },
        devBarLoading(state, b) {
            state.loading = b;
        }
    },
    actions: {
        updateDevInfo({commit, state}) {
            console.log(state);
            const dwzh = StoreSaveData('loginInfo').unitAccount;
            // 获取单位基本信息
            commit('devBarLoading', true);
            Api_devKfsjbxxcx(dwzh).then().then(res => {
                commit('devBarLoading', false);
                if (res.code === '0000000') {
                    let data = JSON.parse(res.body);
                    console.log(data,'打印数据')

                    // 更新vuex
                    commit('devinfoAdd', data.result);
                    // 保存在本地储存
                    sessionStorage.setItem('devinfo', JSON.stringify(data.result));
                } else {
                    this.$Notice.error({
                        title: res.message
                    });
                }
            }).catch(err => {
                commit('devBarLoading', false);
                console.error(err);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/devinfo.js